// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account[data-v-a524a868]{display:flex;flex-direction:column;max-width:784px;padding-left:100px}.account .form-input[data-v-a524a868] .label{margin:12px 0}@media(max-width:960px){.account[data-v-a524a868]{padding:0 16px;max-width:none}}.account .account-modal__toggle[data-v-a524a868]{margin-bottom:24px}.account .secondary-button[data-v-a524a868]{width:-moz-fit-content;width:fit-content}.account .account-delete-button[data-v-a524a868]{margin-top:30px}", ""]);
// Exports
module.exports = exports;
